import { mergeClassNames } from '../../style';

type InternalHeadingProps = {
  children: React.ReactNode;
  level: 'h1' | 'h2' | 'h3' | 'h4';
  size: 's' | 'm' | 'l' | 'xl';
  className?: string;
  title?: string;
};

const InternalHeading = ({ children, level, size, className: customClassName = '', title }: InternalHeadingProps) => {
  const headingStyle = mergeClassNames([
    { className: 'core-typography-heading-extra-large', include: size === 'xl' },
    { className: 'core-typography-heading-large', include: size === 'l' },
    { className: 'core-typography-heading-medium', include: size === 'm' },
    { className: 'core-typography-heading-small', include: size === 's' },
    { className: customClassName },
  ]);

  const Element = level;
  return (
    <Element className={headingStyle} title={title}>
      {children}
    </Element>
  );
};

type HeadingProps = {
  children: InternalHeadingProps['children'];
  level?: InternalHeadingProps['level'];
  className?: InternalHeadingProps['className'];
  title?: string;
};

export const HeadingSmall = ({ children, level = 'h4', className, title }: HeadingProps) => (
  <InternalHeading level={level} size="s" className={className} title={title}>
    {children}
  </InternalHeading>
);

export const HeadingMedium = ({ children, level = 'h3', className, title }: HeadingProps) => (
  <InternalHeading level={level} size="m" className={className} title={title}>
    {children}
  </InternalHeading>
);

export const HeadingLarge = ({ children, level = 'h2', className, title }: HeadingProps) => (
  <InternalHeading level={level} size="l" className={className} title={title}>
    {children}
  </InternalHeading>
);

export const HeadingExtraLarge = ({ children, level = 'h1', className, title }: HeadingProps) => (
  <InternalHeading level={level} size="xl" className={className} title={title}>
    {children}
  </InternalHeading>
);
